import { all } from 'redux-saga/effects'

import result from './result/saga'

export default function* depreciationSaga() {
  yield all([result()])
}
